import { Box, styled } from '@mui/material'

export default styled(Box)(({ theme }) => ({
  color: theme.palette.error.main
}))
